<template>
    <div>
        <div :class="['page ch-account',{ off: !pageOn }]">
            <VHeader type="back" @back="back" />
            <div class="page-content" :style="{ backgroundColor: backgroundColor, color: fontColor }">
                <!-- <img class="page-image" src="/CHMyAccount.png" style="display: none;" /> -->
                <div @click="updateAvatar" style="width: 50px;height: 50px;position: relative;margin: 20px calc(50% - 30px);border: 2px solid white;border-radius: 50%;padding: 10px;">
                    <img v-if="!avatar" :src="man" style="width: 100%;"  />
                    <img v-if="avatar" :src="avatar" style="transform: scale(1.4);border-radius: 50%;width:100%" />
                </div>
                <p class="btn sm-avatar" :style="{ backgroundColor: btnColor, color: btnFontColor }" @click="updateAvatar">edit</p>
                <div>
                    <p style="text-align: center;width: 100%;margin: 20px 0px;font-size: 28px;">MY ACCOUNT</p>
                    <p style="text-align: center;">Name</p>
                    <p class="ta-c fs-20" :style="{ color: infoFontColor }">{{ name }}</p>
                    <p style="margin: 20px 0px 0px 0px;text-align: center;">Account Number</p>
                    <p class="ta-c fs-20" :style="{ color: infoFontColor }">{{ customerNo }}</p>                    
                    <p style="margin: 20px 0px 0px 0px;text-align: center;">Membership Status</p>
                    <p class="ta-c fs-20" :style="{ color: infoFontColor }">Active</p>
                    <p style="margin: 20px 0px 0px 0px;text-align: center;">Mobile</p>
                    <p class="ta-c fs-20" :style="{ color: infoFontColor }">{{ phone }}</p>
                    <p style="margin: 20px 0px 0px 0px;text-align: center">Email</p>
                    <p class="ta-c fs-20" :style="{ color: infoFontColor }">{{ email }}</p>
                    <p class="btn" :style="{ 'margin-top': '40px', backgroundColor: btnColor, color: btnFontColor }" @click="pushPage('edit-copper')">EDIT ACCOUNT</p>
                    <div class="line" style="float: left;margin:0px 0px 0px 0px;width: 100%;">
                        <p style="text-decoration: underline;margin:10px;font-size: 17px;text-align: center;" @click="pushPage('terms')">Terms & Conditions</p>
                        <p style="text-decoration: underline;margin:10px;font-size: 17px;text-align: center;" @click="pushPage('privacy')">Privacy Notice</p>
                        <p style="text-decoration: underline;margin:10px;font-size: 17px;text-align: center;" @click="signOut">Sign Out</p>
                    </div>
                </div>
            </div>    
        </div>
        <EditCopper v-if="pages.indexOf('edit-copper') > -1" @updateMember="updateMember" />
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapMutations } from 'vuex'
import EditCopper from '@/components/EditCopper.vue'

export default {
    name: 'ch-account',
    components: {
        VHeader,
        EditCopper
    },
    mixins: [ pageOn ],
    computed: {
        customer_id () { return this.$store.state._id },
        customerID () { return this.$store.state.id },
        client_id () { return this.$store.state.client_id },
        currentName () { return this.$store.state.name },
        currentEmail () { return this.$store.state.email },
        currentPhone () { return this.$store.state.phone },
        customerNo () { return this.$store.state.customerNo },
        pages () { return this.$store.state.pages },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor }, 
        infoFontColor () { return this.$store.state.infoFontColor },
        man () { return this.$store.state.man },
        avatar () { return this.$store.state.avatar }   
    },
    data () {
        return {
            name: '',
            email: '',
            phone: ''
        }
    },
    mounted () {
        this.name = this.currentName;
        this.email = this.currentEmail;
        this.phone = this.currentPhone;
    },
    methods: {
        updateAvatar () {
            this.pushPage('edit-avatar');
        },
        signOut () {
            Alert.yesno('Sign out from this device ?',yes => {
                if ( !yes ) return;
                this.clearAuth();
                this.setPages(['home','copper']);
            })
        },
        updateMember ( customer ) {

            var { name, mobile, email, client_id, customerID, customer_id, _id } = this;
            
            console.log('customer.sendEMAIL',customer.sendEMAIL);

            WebSoc.SEND({ t: 'updateLoyaltyCustomer', data: { sendSMS: customer.sendSMS, sendEMAIL: customer.sendEMAIL, name: customer.name, phone: customer.phone, email: customer.email, client_id, customer_id  }},resp => {
                if ( resp.success ) {
                    //this.name = customer.name;
                    //this.email = customer.email;
                    //this.phone = customer.phone;
                    
                    this.setValue({ k: 'name', v: customer.name });
                    this.setValue({ k: 'email', v: customer.email });
                    this.setValue({ k: 'phone', v: customer.phone });
                    this.setValue({ k: 'sendSMS', v: customer.sendSMS });
                    this.setValue({ k: 'sendEMAIL', v: customer.sendEMAIL });
                    Alert.message('Your Account has been updated.');
                }
            });
        },
        back () {
            this.pageOn = false;
        },
        ...mapMutations(['setPages','clearAuth','pushPage','setValue'])
    }
}

</script>

<style lang="scss">
p.btn.sm-avatar {
    position: absolute;
    line-height: 28px;
    width: 100px;
    top: 42px;
    left: calc(50% + 55px);
    margin: 0px !important;
}
</style>